import { render, staticRenderFns } from "./BannedKeywordsCard.vue?vue&type=template&id=0e879d7c&"
import script from "./BannedKeywordsCard.vue?vue&type=script&lang=ts&"
export * from "./BannedKeywordsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports